export default __webpack_public_path__ + "static/media/coastertrack.b962eb5e.png";